import * as commonConst from 'app/constants/commons';
import { UnknownAction } from '@reduxjs/toolkit';

let initState = {
  loading: false,
  menuVocabularies: [],
}

const commons = (state = initState, action: UnknownAction) => {
  switch (action.type) {
    case commonConst.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    case commonConst.SET_MENU_VOCABULARIES:
      return {
        ...state,
        menuVocabularies: action.payload
      }
    default:
      return state;
  }
}

export default commons
